<div class="bh-tooltip bh-tooltip-{{position}}">
  {{description}}
</div>

